import {Router} from 'express';

/* eslint-disable new-cap */
let router = Router();
/* eslint-enable new-cap */

import productsController from '../controllers/ProductsController';

const products = new productsController();

router.get('/', products.index);
// router.get('/for-clients', features.clientFeatures);
// router.get('/for-professionals', features.professionalsFeatures);

export default router;
